<template>
  <CrudList
    title="Usuarios eliminados"
    storeName="Deleted_users"
    slot-scope="{ item }"
    sortable
    canSearch
    labelDelete="Restaurar"
    :canAdd="false"
    :canEdit="false"
    :canDelete="true"
    titleDeleted="Restaurar el registro"
    descriptionDeleted="¿Quieres restaurar este registro?"
    next-link="/admin/coins_refunds"
    :breadcrumbs="[
      {
        text: 'Gestión de usuarios',
        disabled: false,
        href: '/admin/deleted_users'
      },
      {
        text: 'Usuarios eliminados',
        disabled: false,
        href: '#'
      },
    ]"
  >
    <template v-slot:completed_name="{item}">
      {{ item.name || '' }} {{ item.last_name || ''}}
    </template>

  </CrudList>
</template>

<script>
import CrudList from "@/components/Crud/CrudList";

export default {
  components: { CrudList },
};
</script>
